import type { CaseRecord, OcrField } from '../types/notice';

export const sampleCase: CaseRecord = {
  caseNo: 'DMP/AI/2025/0614/0748',
  caseDate: '১৪/০৬/২০২৫',
  caseTime: 'সকাল ০৭:৪৮',
  vehicle: 'ঢাকা মেট্রো-গ-২৩-৭১০৭',
  owner: 'মোঃ মিলন মিয়া',
  mobile: '০১৮৩০০৯০৮১৯',
  address: 'দেওয়ানদাড়ি, ত্রিশাল, ময়মনসিংহ',
  offence: 'অবৈধ পার্কিং / প্রতিবন্ধকতা',
  location: 'এলিভেটেড এক্সপ্রেসওয়ে',
  law: 'সড়ক পরিবহন আইন, ২০১৮, ধারা ১১৮',
  hearingDate: '০২/০৭/২০২৫',
  hearingTime: 'সকাল ১০:০০'
};

// Values as first read by the OCR engine (some deliberately imperfect for the demo)
export const ocrRawValues: CaseRecord = {
  ...sampleCase,
  address: 'দেওয়ানদাড়ী, ত্রিশাল, ময়মনসিংহ',
  offence: 'অবৈধ পার্কিং / প্রতিবন্ধ্কতা',
  law: 'সড়ক পরিবহন আইন, ২০১৮, ধারা ১১৪'
};

export const noticeMeta = {
  verificationId: 'DMP-2025-061400748',
  documentId: 'DMP-DOC-2025-0748-V1',
  memoNo: '৬৪১/১৭৭১',
  issueDate: '১৪/০৬/২০২৫',
  token: '7K9Q-X2MP-4RTA',
  verifyUrlDisplay: 'https://verify-demo.dmp.gov.bd/v/7K9QX2MP4RTA',
  qrValue: 'https://verify-demo.dmp.gov.bd/v/7K9QX2MP4RTA',
  hash: '3f9a7c21e04b8d55a1c6f2e9b7d340a18c5e6f9021b7d4e3a6c8f1b20e9d7c21',
  division: 'তেজগাঁও ট্রাফিক বিভাগ',
  mobileMasked: '০১৮৩০****১৯',
  ownerMasked: 'মোঃ মি*** মিয়া',
  signatory: {
    name: 'মোঃ কামরুল হাসান',
    title: 'উপ-পুলিশ কমিশনার',
    dept: 'ট্রাফিক বিভাগ (তেজগাঁও), ডিএমপি, ঢাকা'
  }
};

export const ocrFields: OcrField[] = [
  { key: 'caseNo', label: 'মামলা নম্বর', confidence: 98 },
  { key: 'caseDate', label: 'মামলার তারিখ', confidence: 97 },
  { key: 'caseTime', label: 'মামলার সময়', confidence: 95 },
  { key: 'vehicle', label: 'গাড়ির নম্বর', confidence: 96 },
  { key: 'owner', label: 'মালিকের নাম', confidence: 91 },
  { key: 'mobile', label: 'মোবাইল নম্বর', confidence: 99 },
  { key: 'address', label: 'ঠিকানা', confidence: 84 },
  { key: 'offence', label: 'অপরাধের ধরন', confidence: 87 },
  { key: 'location', label: 'অপরাধের স্থান', confidence: 93 },
  { key: 'law', label: 'আইন/ধারা', confidence: 82 },
  { key: 'hearingDate', label: 'হাজিরার তারিখ', confidence: 94 },
  { key: 'hearingTime', label: 'হাজিরার সময়', confidence: 92 }
];

export const LOW_CONFIDENCE = 90;

export const citizenGuidelines = [
  'QR কোড স্ক্যান করে নোটিশের সত্যতা যাচাই করুন।',
  'শুধুমাত্র ডিএমপির অফিসিয়াল ওয়েবসাইটে তথ্য যাচাই করুন।',
  'অপরিচিত SMS বা লিংকের মাধ্যমে অর্থ প্রদান করবেন না।',
  'নোটিশের তথ্যের সাথে অনলাইন তথ্য মিলিয়ে দেখুন।',
  'সন্দেহজনক নোটিশ পাওয়া গেলে ডিএমপিকে জানান।',
  'নির্ধারিত আইনগত নির্দেশনা অনুসরণ করুন।'
];

export const workflowStages = [
  { label: 'নোটিশ আপলোড', officer: 'এএসআই মোঃ রাকিবুল হাসান', at: '১৪/০৬/২০২৫, ১০:১২', comment: 'স্ক্যানার থেকে মূল নোটিশ আপলোড করা হয়েছে' },
  { label: 'AI/OCR সম্পন্ন', officer: 'AI/OCR ইঞ্জিন (স্বয়ংক্রিয়)', at: '১৪/০৬/২০২৫, ১০:১৩', comment: 'গড় নির্ভুলতা ৯৩%; ৩টি ক্ষেত্র পর্যালোচনা প্রয়োজন' },
  { label: 'তথ্য সংশোধন', officer: 'এএসআই মোঃ রাকিবুল হাসান', at: '১৪/০৬/২০২৫, ১১:০৫', comment: 'ঠিকানা, অপরাধের ধরন ও ধারা সংশোধন করা হয়েছে' },
  { label: 'যাচাই সম্পন্ন', officer: 'এসআই নাসরিন আক্তার', at: '১৪/০৬/২০২৫, ১৪:২০', comment: 'মূল নোটিশের সাথে সকল তথ্য মিলেছে' },
  { label: 'অনুমোদন', officer: 'এসি মোঃ শাহরিয়ার আলম', at: '১৫/০৬/২০২৫, ০৯:৪০', comment: 'নিরাপদ নোটিশ তৈরির জন্য অনুমোদিত' },
  { label: 'QR নোটিশ তৈরি', officer: 'সিস্টেম (স্বয়ংক্রিয়)', at: '১৫/০৬/২০২৫, ০৯:৪২', comment: 'Verification ID ও ডিজিটাল স্বাক্ষর যুক্ত' },
  { label: 'প্রিন্ট ও প্রেরণ', officer: 'মোঃ জাহিদুল করিম', at: '১৫/০৬/২০২৫, ১২:৩০', comment: 'বাংলাদেশ ডাক বিভাগ — রেজিস্টার্ড ডাক' }
];
